import React, { Component } from 'react';
import Button from '../Button';
import Link from '../Link';
import { translate } from 'react-polyglot';
import './SiteFooterNotice.scss';
import { links, swCookies, subDomains } from '../../lib/constants';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

@translate()
class SiteFooterNotice extends Component {

  handleAgreementClick = () => {
    const { cookies, isConsentGiven, updateConsent } = this.props;
    cookies.set(swCookies.consent, true, { path: '/'});

    if(isConsentGiven === false) {
      updateConsent()
    }
  }

  render() {
    const baseClassName = 'pb-site-footer-notice';
    const classNames = [baseClassName];
    const url = window.location.host
    const subDomain = url.split('.')[0]

    const {
      t,
      isRtl,
      cookies,
      isFetchingMe,
      isLoggedIn, 
      isConsentGiven, 
    } = this.props;

    let shouldDisplayCookieConsent = (isLoggedIn ? !isConsentGiven : !cookies.get(swCookies.consent)) && subDomain !== subDomains.ddl && subDomain !== subDomains.gd

    if (isFetchingMe) {
      shouldDisplayCookieConsent = false
    }

    return (
        shouldDisplayCookieConsent 
        ?
        <div className={`${baseClassName}`}>
          <div dir={isRtl ? "rtl" : "ltr"} className={classNames.join(' ')}>
            {t("SiteFooterNotice.text")} <Link href={links.termsOfUse()}> {t("SiteFooterNotice.terms-and-conditions")} </Link> {t("SiteFooterNotice.and")} <Link href={links.privacyPolicy()}> {t("SiteFooterNotice.privacy-policy")}. </Link> 
            <Button parentClassName={`${baseClassName}__agree-btn`}
              label= {t('SiteFooterNotice.agree')}
              onClick = {this.handleAgreementClick}
            />
          </div>
        </div>
        :
        null      
    );
  }
}

SiteFooterNotice.propTypes = {
  cookies: instanceOf(Cookies).isRequired,
};

export default withCookies(SiteFooterNotice)




// WEBPACK FOOTER //
// ./src/components/SiteFooter/SiteFooterNotice.jsx